export const PL = {
  "nav.services": "Usługi",
  "nav.pricing": "Cennik",
  "nav.request_viewing": "Umów oglądanie",
  "nav.why_us": "Dlaczego my",
  "nav.faq": "Pytania",
  "nav.contact": "Kontakt",
  "nav.owner": "Jesteś właścicielem?",
  "proc.step": "KROK",
  "meta.title": "Unity Real Estate — mieszkania na wynajem i pomoc w przeprowadzce do Warszawy",
  "lang.Turkish": "Turecki",
  "lang.English": "Angielski",
  "lang.Azerbaijani": "Azerski",
  "lang.Polish": "Polski",
  "common.whatsapp": "WhatsApp",
  "common.call": "Zadzwoń",
  "hero.location": "Warszawa · Polska",
  "hero.live": "Odpisujemy w ciągu godziny",
  "hero.owner_cta": "Masz mieszkanie? Znajdziemy najemcę",
  "hero.title.1": "Twój nowy dom w Warszawie —",
  "hero.title.2": "bez stresu i papierkowej roboty.",
  "hero.subtitle": "Dopiero przyjeżdżasz do Warszawy? Mieszkasz tu i chcesz się przeprowadzić? A może szukasz kogoś, kto przejmie Twoją umowę najmu? Znajdziemy mieszkanie, załatwimy formalności i porozmawiamy z właścicielem za Ciebie — w Twoim języku.",
  "hero.cta_whatsapp": "Napisz na WhatsApp",
  "hero.trust_stars": "Zaufało nam już ponad 300 rodzin z różnych stron świata",
  "hero.stats.families": "rodzin już u siebie",
  "hero.stats.time_label": "Średnio do odbioru kluczy",
  "hero.stats.time_value": "5 dni",
  "hero.stats.docs_label": "Pomoc z dokumentami",
  "hero.stats.docs_value": "W cenie",
  "hero.stats.lang_label": "Języki, w których mówimy",
  "hero.stats.districts_label": "Dzielnice",
  "hero.stats.districts_value": "Śródmieście, Mokotów, Wola +12",
  "hero.stats.quote": "\"PESEL, umowa z właścicielem i przeprowadzka — wszystko załatwione w niecały tydzień.\"",
  "hero.stats.quote_author": "— Ayşe, Stambuł → Warszawa",
  "hero.scroll": "przewiń",
  "aud.eyebrow": "Komu pomagamy",
  "aud.title.1": "Trzy różne sytuacje,",
  "aud.title.2": "jeden zespół, na który możesz liczyć.",
  "aud.blurb": "Pomagamy we wszystkim, co dotyczy mieszkania w Warszawie — od pierwszego dnia w Polsce aż po oddanie kluczy.",
  "aud.new.title": "Przeprowadzam się do Warszawy",
  "aud.new.text": "Dopiero przyjeżdżasz i potrzebujesz mieszkania, PESEL-u, umowy najmu i całej reszty? Przeprowadzimy Cię przez wszystko krok po kroku.",
  "aud.new.msg": "Cześć! Przeprowadzam się do Warszawy i potrzebuję pomocy ze znalezieniem mieszkania i dokumentami.",
  "aud.change.title": "Mieszkasz już w Warszawie?",
  "aud.change.text": "Chcesz lepszą lokalizację, więcej miejsca albo niższy czynsz? Znajdziemy Ci kolejne mieszkanie.",
  "aud.change.msg": "Cześć! Mieszkam już w Warszawie i szukam nowego mieszkania. Pomożecie?",
  "aud.replace.title": "Szukasz kogoś na swoje miejsce?",
  "aud.replace.text": "Musisz wyprowadzić się przed końcem umowy? Znajdziemy osobę, która przejmie Twoją umowę, i dogadamy wszystko z właścicielem.",
  "aud.replace.msg": "Cześć! Szukam kogoś, kto przejmie moją umowę najmu w Warszawie. Pomożecie?",
  "rv.eyebrow": "Umów oglądanie",
  "rv.title.1": "Napisz, czego szukasz —",
  "rv.title.2": "resztą zajmiemy się my.",
  "rv.blurb": "Wypełnij kilka pól, a otworzymy WhatsApp z gotową wiadomością. Możesz pisać po polsku, angielsku, turecku lub azersku — zwykle odpisujemy w ciągu godziny.",
  "rv.benefit.1": "Tylko sprawdzone oferty",
  "rv.benefit.2": "Żadnych opłat na start",
  "rv.benefit.3": "Pomoc z dokumentami w cenie",
  "rv.f.name": "Imię (opcjonalnie)",
  "rv.f.name.ph": "np. Anna",
  "rv.f.type": "Czego szukasz?",
  "rv.f.type.ph": "Wybierz",
  "rv.f.district": "Dzielnica (możesz wybrać kilka)",
  "rv.f.district.ph": "Wybierz dzielnicę",
  "rv.f.district.summary": "wybrane dzielnice",
  "rv.f.budget": "Budżet (PLN / mies.)",
  "rv.f.budget.ph": "np. 3500",
  "rv.f.date": "Od kiedy? (opcjonalnie)",
  "rv.f.date.ph": "Wybierz datę",
  "rv.submit": "Wyślij na WhatsApp",
  "rv.no_store": "Nie zapisujemy danych z formularza — wiadomość trafia prosto na WhatsApp.",
  "rv.err": "Wybierz przynajmniej jedną dzielnicę, rodzaj mieszkania i wpisz budżet.",
  "rv.opening": "Otwieramy WhatsApp z Twoją wiadomością…",
  "rv.msg.hi": "Cześć!",
  "rv.msg.hi_name": "Cześć, tu {name}.",
  "rv.msg.intro": "Chcę umówić oglądanie przez Unity Real Estate:",
  "rv.msg.district": "Dzielnica",
  "rv.msg.districts": "Dzielnice",
  "rv.msg.type": "Rodzaj",
  "rv.msg.budget": "Budżet",
  "rv.msg.move_in": "Od kiedy",
  "rv.msg.flexible": "Elastycznie",
  "rv.msg.outro": "Podeślecie dostępne oferty? Dzięki!",
  "type.room": "Pokój we wspólnym mieszkaniu",
  "type.studio": "Kawalerka",
  "type.flat-1-2": "Mieszkanie 1–2 pokoje",
  "type.flat-3plus": "Mieszkanie 3+ pokoje",
  "type.house": "Dom",
  "district.any": "Obojętnie / jeszcze nie wiem",
  "srv.eyebrow": "W czym pomagamy",
  "srv.title.1": "Cała przeprowadzka,",
  "srv.title.2": "od A do Z.",
  "srv.blurb": "Jesteśmy małym zespołem i do każdej przeprowadzki podchodzimy jak do własnej. Bez pośredników, ukrytych opłat i bariery językowej.",
  "srv.search.title": "Mieszkania, pokoje i domy",
  "srv.search.desc": "Sprawdzone oferty w całej Warszawie — od pokoju we wspólnym mieszkaniu po mieszkanie dla rodziny. Dobierzemy właściciela, dzielnicę i cenę do Ciebie.",
  "srv.search.points": ["Kawalerki i 1–4 pokoje", "Na krótko i na dłużej", "Też ze zwierzakiem"],
  "srv.docs.title": "Dokumenty i formalności",
  "srv.docs.desc": "PESEL, meldunek, tłumaczenie umowy najmu — papierami zajmiemy się my, a Ty możesz spokojnie się urządzać.",
  "srv.docs.points": ["PESEL", "Tłumaczenie umowy", "Meldunek"],
  "srv.view.title": "Oglądanie i negocjacje",
  "srv.view.desc": "Obejrzymy mieszkanie z Tobą albo za Ciebie, wynegocjujemy czynsz i dopilnujemy, żeby umowa była uczciwa także dla Ciebie.",
  "srv.view.points": ["Na miejscu", "Online", "Negocjacje"],
  "srv.lang.title": "W Twoim języku",
  "srv.lang.desc": "Mówimy po polsku, angielsku, turecku i azersku. Będziemy Twoim głosem na każdym spotkaniu, przez telefon i przy podpisywaniu umowy.",
  "srv.cta_about": "Cześć! Chcę dowiedzieć się więcej o usłudze: {title}",
  "proc.eyebrow": "Jak to działa",
  "proc.title.1": "Od pierwszej wiadomości",
  "proc.title.2": "do kluczy w ręku.",
  "proc.s1.t": "Napisz, czego szukasz",
  "proc.s1.b": "Budżet, dzielnica, termin przeprowadzki. Wystarczy krótka wiadomość na WhatsApp w Twoim języku.",
  "proc.s2.t": "Wybieramy i pokazujemy",
  "proc.s2.b": "Wysyłamy krótką listę prawdziwych, sprawdzonych ofert — bez fałszywych ogłoszeń i pośredników. Oglądasz na miejscu albo online.",
  "proc.s3.t": "Załatwiamy formalności",
  "proc.s3.b": "Tłumaczymy umowę, wyjaśniamy po ludzku każdy jej punkt i razem z Tobą załatwiamy PESEL i meldunek.",
  "proc.s4.t": "Wprowadzasz się",
  "proc.s4.b": "Klucze są Twoje. W pierwszych tygodniach dalej pomagamy z prądem, internetem i wszystkim, czego potrzebujesz.",
  "pri.eyebrow": "Cennik",
  "pri.title.1": "Proste pakiety,",
  "pri.title.2": "cena dopasowana do Ciebie.",
  "pri.blurb": "Każda przeprowadzka wygląda inaczej — na cenę wpływa budżet, termin i to, ile formalności trzeba załatwić. Wybierz pakiet, a w ciągu godziny wyślemy Ci jasną wycenę na WhatsApp.",
  "pri.cta": "Poproś o wycenę",
  "pri.best": "Najczęściej wybierany",
  "pri.included": "Co dostajesz",
  "pri.not_included": "Czego nie obejmuje",
  "pri.guarantees": "Bez ukrytych opłat · Jasna wycena, zanim zaczniemy · Pierwsza rozmowa zawsze za darmo",
  "pri.t1.name": "Szukanie mieszkania",
  "pri.t1.tag": "Znajdziemy właściwe mieszkanie — bieganie po oglądaniach zostaw nam.",
  "pri.t1.inc": ["Pomoc w wyborze budżetu i dzielnicy", "Krótka lista sprawdzonych ofert", "Oglądanie na miejscu lub online", "Negocjacja czynszu i kaucji", "Odbiór mieszkania i kluczy"],
  "pri.t1.no": ["Pomoc z dokumentami", "Wsparcie po przeprowadzce"],
  "pri.t1.msg": "Cześć! Poproszę o wycenę pakietu „Szukanie mieszkania”.",
  "pri.t2.name": "Szukanie + dokumenty",
  "pri.t2.tag": "Najczęstszy wybór osób, które dopiero przyjeżdżają do Warszawy.",
  "pri.t2.inc": ["Wszystko z pakietu „Szukanie mieszkania”", "Tłumaczenie umowy i omówienie każdego punktu", "Pomoc przy wniosku o PESEL", "Pomoc z meldunkiem", "Pomoc z kontem w banku i internetem"],
  "pri.t2.no": ["Sprawy pobytowe i wizowe"],
  "pri.t2.msg": "Cześć! Poproszę o wycenę pakietu „Szukanie + dokumenty”.",
  "pri.t3.name": "Przeprowadzka pod klucz",
  "pri.t3.tag": "Wszystko załatwimy my — Ty po prostu przyjeżdżasz.",
  "pri.t3.inc": ["Wszystko z pakietu „Szukanie + dokumenty”", "Odbiór z lotniska w dniu przylotu", "Przepisanie mediów i umów", "Umówienie wizyty w sprawie karty pobytu i pójście z Tobą", "30 dni wsparcia po przeprowadzce"],
  "pri.t3.no": [],
  "pri.t3.msg": "Cześć! Poproszę o wycenę pakietu „Przeprowadzka pod klucz”.",
  "why.eyebrow": "Dlaczego Unity",
  "why.title.1": "Pomagamy poczuć się",
  "why.title.2": "w Warszawie jak w domu",
  "why.title.3": "od pierwszego dnia.",
  "why.blurb": "Przeprowadzka do nowego kraju to i tak sporo stresu. Formalności, szukanie mieszkania i negocjacje bierzemy na siebie — Ty możesz po prostu zacząć tu żyć, zamiast walczyć z urzędami.",
  "why.langs": "Języki",
  "why.r1.t": "Znamy drogę nowych mieszkańców",
  "why.r1.x": "Pracujemy z osobami, które przeprowadzają się do Warszawy — wiemy, które formalności i pułapki sprawiają najwięcej kłopotu.",
  "why.r2.t": "Bez ukrytych opłat",
  "why.r2.x": "Cenę ustalamy jasno na samym początku. Żadnych niespodzianek przy podpisywaniu umowy.",
  "why.r3.t": "Jedna osoba od początku do końca",
  "why.r3.x": "Masz jedną osobę kontaktową od pierwszej wiadomości do odbioru kluczy — i także później.",
  "why.r4.t": "Tylko sprawdzone oferty",
  "why.r4.x": "Sami odwiedzamy i sprawdzamy mieszkania. Żadnych fałszywych ani zdublowanych ogłoszeń.",
  "why.cta": "Zacznij przeprowadzkę z nami",
  "tst.eyebrow": "Opinie klientów",
  "tst.title.1": "Pomogliśmy już ponad 300 rodzinom",
  "tst.title.2": "z 5 krajów.",
  "tst.1.q": "Od pierwszego dnia rozmawiali ze mną po turecku. W 5 dni znaleźli mi piękne mieszkanie na Mokotowie i załatwili PESEL. Bez nich byłabym zupełnie zagubiona.",
  "tst.1.name": "Ayşe K.",
  "tst.1.from": "Stambuł → Warszawa",
  "tst.2.q": "Uczciwi, szybcy i wynegocjowali dużo niższy czynsz, niż mi proponowano. Pomogli nawet z internetem i meldunkiem w urzędzie. Bardzo polecam.",
  "tst.2.name": "Rəşad M.",
  "tst.2.from": "Baku → Warszawa",
  "tst.3.q": "Nie mówię po polsku i bałam się polskich umów najmu. Przetłumaczyli mi każdy punkt i dopilnowali, żebym nie podpisała niczego niekorzystnego.",
  "tst.3.name": "Emma P.",
  "tst.3.from": "Londyn → Warszawa",
  "faq.eyebrow": "Pytania",
  "faq.title.1": "Przeprowadzka do Warszawy —",
  "faq.title.2": "odpowiedzi na Twoje pytania.",
  "faq.blurb": "Konkretnie o kaucji, PESEL-u, rachunkach i prawach najemcy. Nie ma tu Twojego pytania? Napisz do nas po polsku, angielsku, turecku lub azersku.",
  "faq.cta": "Zapytaj na WhatsApp",
  "faq.cta.msg": "Cześć! Mam pytanie o wynajem mieszkania w Warszawie.",
  "faq.q1": "Co to jest PESEL i czy potrzebuję go do wynajmu?",
  "faq.a1": "PESEL to polski numer identyfikacyjny. Do podpisania umowy najmu nie jest potrzebny, ale przyda Ci się prawie wszędzie: u lekarza, w banku, przy umowie o pracę i w sprawach podatkowych. Pomożemy Ci złożyć wniosek w urzędzie dzielnicy.",
  "faq.q2": "Ile wynosi kaucja?",
  "faq.a2": "Zwykle kaucja to równowartość jednego miesięcznego czynszu, a przy droższych mieszkaniach lub bardzo krótkim najmie — dwóch. Pierwszy czynsz płacisz z góry. Przed podpisaniem sprawdzamy, czy zasady zwrotu kaucji są jasno zapisane w umowie.",
  "faq.q3": "Kto płaci prowizję — ja czy właściciel?",
  "faq.a3": "Nasza opłata jest ustalana z góry i jasna od początku — bez ukrytej prowizji. Zanim zaczniemy szukać, powiemy Ci, czy coś zapłacisz, ile i kiedy. Jeśli prowizję pokrywa właściciel, Ty nie płacisz nam nic.",
  "faq.q4": "Jak długo trwa znalezienie mieszkania w Warszawie?",
  "faq.a4": "Zwykle od 3 do 10 dni od pierwszej wiadomości do przeprowadzki. Pokoje i kawalerki znajdują się szybciej. Większe mieszkania dla rodzin, np. na Mokotowie, w Śródmieściu czy w Wilanowie, mogą zająć 2–3 tygodnie.",
  "faq.q5": "Czy mogę wynająć mieszkanie bez polskiej umowy o pracę albo jeszcze przed przyjazdem?",
  "faq.a5": "Tak. Wielu naszych klientów podpisuje pierwszą umowę, zanim przyjedzie do Warszawy. Właściciele zwykle proszą o potwierdzenie dochodów, paszport i referencje — pomożemy Ci je przetłumaczyć i przedstawić.",
  "faq.q6": "Jakie mam prawa jako najemca w Polsce?",
  "faq.a6": "Polskie prawo dobrze chroni najemców. Właściciel nie może dowolnie podnosić czynszu ani wchodzić do mieszkania bez uprzedzenia, a kaucję musi oddać w ciągu miesiąca od wyprowadzki — potrącając tylko udokumentowane szkody. Każdy punkt umowy sprawdzamy, zanim ją podpiszesz.",
  "faq.q7": "Kto płaci rachunki (woda, prąd, gaz, internet)?",
  "faq.a7": "Zwykle do czynszu doliczany jest czynsz administracyjny (utrzymanie budynku, czasem woda i ogrzewanie), a za prąd i internet płacisz osobno. Przed podpisaniem zawsze sprawdzamy, co jest wliczone.",
  "faq.q8": "Pomożecie mi znaleźć osobę, która przejmie moją umowę?",
  "faq.a8": "Tak — to jedna z najczęstszych próśb. Wystawimy ogłoszenie, wybierzemy kandydatów, przeprowadzimy oglądania i dogadamy przekazanie z Twoim właścicielem, żeby Twoja kaucja była bezpieczna.",
  "faq.q9": "Mieszkam już w Warszawie, ale chcę się przeprowadzić — pomożecie?",
  "faq.a9": "Jasne. Znamy rynek, zarządców i uczciwe ceny w poszczególnych dzielnicach. Pomożemy Ci szybciej znaleźć lepsze mieszkanie i bez problemów zakończyć obecną umowę.",
  "faq.q10": "Czy pomagacie tylko osobom z Turcji i Azerbejdżanu?",
  "faq.a10": "Nie — pomagamy każdemu, kto przeprowadza się do Warszawy. Mówimy po polsku, angielsku, turecku i azersku i pracujemy z ludźmi z wielu krajów.",
  "ctc.eyebrow": "Porozmawiajmy",
  "ctc.title.1": "Znajdźmy razem",
  "ctc.title.2": "Twoje miejsce w Warszawie.",
  "ctc.blurb": "Napisz do nas na WhatsApp po polsku, angielsku, turecku lub azersku. Zwykle odpisujemy w ciągu godziny.",
  "ctc.cta_wa": "Napisz na WhatsApp",
  "ctc.cta_call": "Zadzwoń: {phone}",
  "ctc.phone": "Telefon / WhatsApp",
  "ctc.based": "Gdzie jesteśmy",
  "ctc.based_val": "Warszawa, Polska",
  "ctc.reply": "Czas odpowiedzi",
  "ctc.reply_val": "Zwykle do godziny",
  "ftr.tag": "Pomagamy nowym mieszkańcom Warszawy znaleźć dom i dobrze się tu urządzić — z troską i w ich języku.",
  "ftr.explore": "Na stronie",
  "ftr.contact": "Kontakt",
  "ftr.warsaw": "Warszawa, Polska",
  "ftr.rights": "Wszelkie prawa zastrzeżone.",
  "ftr.chat": "Napisz na WhatsApp",
  "fwa.tip.q": "Szukasz mieszkania w Warszawie?",
  "fwa.tip.a": "Napisz do nas w swoim języku.",
  "fwa.aria": "Napisz na WhatsApp",
  "tst.rating.score": "4.9 / 5",
  "tst.rating.sub": "na podstawie 87 opinii z WhatsApp i spotkań",
  "tst.verified": "Opinia z WhatsApp",
  "tst.4.q": "Przyjechałem z Baku, nie znając ani słowa po polsku. Odebrali mnie z lotniska, w tym samym tygodniu pojechaliśmy na oglądania, a umowę przetłumaczyli mi zdanie po zdaniu.",
  "tst.4.name": "Rəşad A.",
  "tst.4.from": "Baku → Mokotów",
  "wa.default": "Cześć! Szukam mieszkania w Warszawie i potrzebuję pomocy.",
};
